import { combineReducers } from 'redux';
import AuthServices from './AuthServicesReducer';
import ManageOrgs from './ManageOrgsReducer';

const RootReducer = combineReducers({
    AuthServicesList: AuthServices,
    ManageOrgsList: ManageOrgs,
});

export default RootReducer;